import script from "./ProductGuideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductGuideModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductGuideModal.vue?vue&type=style&index=0&id=312f22d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-312f22d4"]])

export default __exports__